import type { T_UniRes } from '@/types'
import type { T_PaymentInfoRes } from '@/types/responses'
import { apiRequest } from '../request'
import { checkResponse, retry, withTimeout } from './helpers'


export const processPayment = async (
  documentId: number| number[],
  toast?: (
    message: string,
    options: { type: 'success' | 'error' },
  ) => void,
  onError?: (message: string) => void,
) => {
  const documents = Array.isArray(documentId) ? documentId : [ documentId ]

  try {
    // Получаем список методов оплаты и балансы пользователя
    const res = checkResponse(
      await retry(
        () => withTimeout(
          apiRequest<T_UniRes<T_PaymentInfoRes>>({
            method: 'money/payment/info',
            param: {
              documents,
            },
          }),

          10000,
        )
      )
    )

    const balance = parseFloat(res?.data?.methods?.[0]?.balance || '0')
    const required = parseFloat(res?.data?.value || '0')

    if (balance < required) {
      onError?.('Недостаточно средств на счёте для покупки. Пополните, пожалуйста, счет и попробуйте снова')
      return false
    }

    // Создаем запрос на ввод средств
    const paymentRequest = checkResponse(
      await retry(
        () => withTimeout(
          apiRequest<T_UniRes<{ id: number }>>({
            method: 'money/payment/request',
            param: {
              documents,
              scenario: 1,
              queue: [
                {
                  id: 'moneys-rur',
                  value: Number(res.data.value),
                },
              ],
            },
          }),

          10000,
        )
      )
    )

    // Начинаем проверку финансового пароля
    checkResponse(
      await retry(
        () => withTimeout(
          apiRequest<T_UniRes<any>>({
            method: 'client/security/start',
            param: {
              type: 'finop',
            },
          }),

          10000,
        )
      )
    )

    // Начинаем оплату запроса:
    checkResponse(
      await retry(
        () => withTimeout(
          apiRequest<T_UniRes<any>>({
            method: 'money/payment/start',
            param: {
              id: paymentRequest.data.id,
              confirm: true,
            },
          }),

          10000,
        )
      )
    )

    toast?.(
      'Оплата прошла успешно',
      { type: 'success' },
    )

    return true
  } catch (err: any) {
    console.error('Ошибка в процессе оплаты:', err)

    if (err.message === 'timeout') {
      onError?.('Время ожидания истекло.\nПожалуйста, попробуйте позже.')
      return false
    }

    if (err.message === 'Network Error' || err.code === 'ERR_NETWORK') {
      onError?.('Ошибка сети.\nПроверьте подключение и попробуйте ещё раз.')
      return false
    }

    const isStructured = (
      typeof err.message === 'string'
      && err.message.includes('|')
    ) as boolean

    if (isStructured) {
      const [ code, msg ] = (err.message as string).split('|')
      onError?.(`Ошибка оплаты.\nКод: ${code}\n${msg}`)
    } else {
      onError?.('Ошибка оплаты.\nПожалуйста, попробуйте позже.')
    }

    return false
  }
}
